import { DynamischeStundenbewertung } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/Stundenbewertung/DynamischeStundenbewertung/DynamischeStundenbewertung';
import { LinkBerechnungsbeispiel } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/Stundenbewertung/DynamischeStundenbewertung/LinkBerechnungsbeispiel';
import { FesteStunden } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/Stundenbewertung/FesteStunden';

import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { Separator } from '@e2n/ui';
import { Heading } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function StundenbewertungInputBlock() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();

  const {
    bezahlungsart: { art },
    arbeitszeitkonto: {
      arbeitstage,
      gehaltsempfaenger: { stundenpensum },
    },
  } = form.state.values.bezahlung;

  const arbeitstageSelected = arbeitstage.length > 0;

  const onlyFesteStundenbewertung =
    (arbeitstageSelected && art === 'fixgehalt') ||
    (art === 'fixgehalt' && stundenpensum === 'woche');

  return (
    <div className="flex flex-col gap-6">
      {onlyFesteStundenbewertung && (
        <Heading>
          {t(
            'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stunden.title',
          )}
        </Heading>
      )}
      <form.Subscribe
        selector={(state) => ({
          stundenbewertung:
            state.values.abwesenheiten.allgemein.stundenBewertung,
        })}>
        {({ stundenbewertung }) =>
          stundenbewertung === 'fest' || onlyFesteStundenbewertung ? (
            <div className="grid md:grid-cols-2">
              <FesteStunden />
            </div>
          ) : stundenbewertung === 'dynamisch' ? (
            <>
              <DynamischeStundenbewertung />
              <Separator />
              <LinkBerechnungsbeispiel />
            </>
          ) : null
        }
      </form.Subscribe>
    </div>
  );
}
